import { twMerge } from 'tailwind-merge'

type Props = {
  label: string
  className?: string
}

export const Badge = ({ label, className }: Props) => {
  return (
    <div
      className={twMerge(`bg-tag text-style-accent leading-4 py-1 px-3 rounded-full ${className}`)}
    >
      {label}
    </div>
  )
}


type StatusBadgeProps = {
  status: 'normal' | 'recoveryMode'
  className?: string
}
export const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  const style = status === 'normal' ? 'bg-green-700 text-green-200' : 'bg-rose-700 text-red-300'
  const label = status === 'normal' ? 'Normal' : 'Recovery Mode'
  return (
    <Badge label={label} className={twMerge(style, className)} />
  )
}